<template>
  <el-dialog title="安全验证" :visible.sync="dialogVisible" width="25%" :close-on-click-modal="false"
    @close="handleClose('formRef')">
    <el-form style="text-align: start;" ref="formRef" :model="form" :rules="rules" label-width="auto">
      <el-form-item label="访问密码" prop="password">
        <el-input v-model="form.password" size="mini" show-password></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="mini" plain @click="dialogVisible = false;">取消</el-button>
      <el-button size="mini" type="primary" plain @click="handleSubmit('formRef')">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import util from '@/untils/util'
import { postCheckCheckpwd } from '../api.js'
export default {
  props: {
    dialog: Boolean,
    id: String,
  },
  data() {
    return {
      projectId: util.session.get('groupId'),
      form: {
        password: '',
      },
      rules: {
        password: { required: true, message: '请输入密码', trigger: 'blur' },
      },
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },
  methods: {
    handleClose(type) {
      this.$refs[type].resetFields()
      this.$emit('close')
    },
    handleSubmit(type) {
      this.$refs[type].validate((valid) => {
        if (!valid) return false

        this.validateAuth()
      })
    },
    async validateAuth() {
      try {
        const params = {
          id: this.id,
          password: this.form.password,
        }

        const { data: res } = await postCheckCheckpwd(params)

        if (res.code == 200) {
          this.$emit('success', this.form.password)
          this.$emit('update:dialog', false)
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
  },
}
</script>

<style></style>
